<wiz-h-divider width="100%" height="100%" gap="0" padding="5px">
  <wiz-hgroup width="350px" height="100%">
    <multi-display #mdMain width="100%" height="100%" [config]="mainConfig">
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <wiz-icon #btnRemove [wizDisabled]="!mayDelete()" (wizClick)="askForDelete()" class="image-purple"
          [wizTooltip]="'$.common.delete.$'" (click)="askForDelete()">delete</wiz-icon>
      </wiz-hgroup>

      <wiz-hgroup target="title" [verticalAlign]="'center'" class="add-btn" gap="10" padding="0 0 10px">
        <wiz-icon #btnCreate [wizTooltip]="'$.workflow.add.$'" tooltipPlacement="right" class="image-back-orange"
          (click)="askForAdd()" [wizDisabled]="cantCreate">add</wiz-icon>
        <wiz-label class="titleLabel" [wizLabel]="'$.workflow.add.$'" [wizTextBehavior]="'truncate'"
          width="100%"></wiz-label>
      </wiz-hgroup>
    </multi-display>
  </wiz-hgroup>

  <!-- zone détail "vraie" -->
  <wiz-vgroup class="section-container-parent" #vgEdition wizValidationContainer width="100%" minWidth="600px"
    height="100%" gap="10" [visible]="false" [wizDisabled]="cantUpdate">
    <!-- entête d'édition -->
    <wiz-hgroup wizValidationContainer width="100%" class="section-container" padding="10px" gap="10">
      
      <!-- boutons d'action -->
      <wiz-vgroup gap="0" height="100%" width="200px" horizontalAlign="center">
        <wiz-button #btnSave [wizIcon]="'arrow-right'" [wizLabel]="'$.common.save.modification.$'"
          [iconPlacement]="'right'" [wizDisabled]="disableButtons()" (wizClick)="doMerge()"></wiz-button>
        <wiz-button #btnCancel class="cancel-button" [wizIcon]="'arrow-left'"
          [wizLabel]="'$.common.cancel.modification.$'" [wizDisabled]="disableButtons()"
          (wizClick)="doCancel()"></wiz-button>
      </wiz-vgroup>
    </wiz-hgroup>

    <!-- détail d'édition -->
    <!--liste des lignes du style -->
    <wiz-hgroup wizValidationContainer width="100%" minWidth="300px" height="100%" class="section-container"
      padding="10px" gap="10" style="overflow-x: auto">
      
      <wiz-vgroup  wizValidationContainer width="300px" height="100%" horizontalAlign="end">
        <wiz-text-input #tiObj [wizLabel]="'$.workflow.obj.$'"></wiz-text-input>
        
        <wiz-text-area #taContent [wizLabel]="'$.workflow.content.$'" width="100%" height="100%" wizValidator
          [wizMaxChars]="2000"></wiz-text-area>    
      
        <wiz-text-area #taParams [wizLabel]="'$.workflow.params.$'" width="100%" height="100%" wizValidator
          ></wiz-text-area>    

        <wiz-dropdown
              #ddState
              width="200px"
              [wizLabelField]="'trsLabel'"
              [wizLabel]="'$.wf.state.$'"
              [wizMandatory]="true"
        ></wiz-dropdown>

        <wiz-datefield #da [wizLabel]="'$.wf.targetdate.$'" width="150px" wizValidator></wiz-datefield>


        <!-- zone de drop -->
        <wiz-group #dropGrp width="200px" height="200px">
          <wiz-vgroup #dropEmpty class="dropZone" *ngIf="!dropFull"
            width="100%" height="100%" horizontalAlign="center" verticalAlign="center"
            (click)="selectFile()" (drop)="dropFile($event)" (dragover)="dover($event)">
            
            <wiz-icon #icoAddFile [wizTooltip]="'$.common.import.$'">upload</wiz-icon>
            <wiz-label wizLabel="$.common.free.drop.message.$"></wiz-label>
          </wiz-vgroup>
          
          <wiz-hgroup #dropFull class="dropZone" *ngIf="dropFull" 
          horizontalAlign="center" verticalAlign="center" style="padding: 5px;"
          width="100%" height="100%">
            <wiz-label [wizLabel]="mediaReference?.shortFileName" [wizTooltip]="mediaReference.fileName" width="100%"
            style="word-break: break-all;"></wiz-label>
            <wiz-vgroup width="28px">
              <wiz-icon #icoDelFile
              style="cursor: pointer; font-size: 20px"
              (click)="clearDropFile()"
              [wizTooltip]="'$.common.delete.$'">delete</wiz-icon>
              <wiz-icon #icoLoadFile 
              [undisableable]="true"
              style="cursor: pointer; font-size: 20px" (click)="loadDropFile()" [wizTooltip]="'$.common.export.$'">download</wiz-icon>
            </wiz-vgroup>
          </wiz-hgroup>
        </wiz-group>

        <!-- image -->
        <wiz-group #imgGp  width="100%" height="100%"><!-- rendu d'un média du FDV-->
          <wiz-vgroup gap="0" width="100%" height="100%">
            <wiz-label #imgLbl  
            [wizLabel]="'$.workflow.media.$'"
            class="componentLabel"></wiz-label>
            <wiz-vgroup gap="0" width="100%" height="100%" horizontalAlign="center" verticalAlign="center">
              <wiz-image style="object-fit: contain;"
                #img
                tabindex="0"
                height="100%"
                width="100%"
                class="img-picker img-freestyle"
                [useHandCursor]="true"
                [sourceObservable]="imgSrcObs"
                [useHandCursor]="true"
                (keydown)="keydownForUpload($event)"
                wizholdable
                (wizHold)="clickForUpload($event)">
                
              </wiz-image><!-- (click)="clickForUpload($event)" -->
            </wiz-vgroup>
            
          </wiz-vgroup>
          <wiz-hgroup width="100%" horizontalAlign="end">
            <wiz-icon
              [visible]="hasImage"
              style="cursor: pointer; font-size: 20px"
              (click)="clearImage()"
              class="image-back-white"
              [wizTooltip]="'$.common.delete.$'"
              >delete</wiz-icon>
          </wiz-hgroup>
          
        </wiz-group>




      </wiz-vgroup>
     
 
      <viz-vgroup width="100%" height="100%">
        <wiz-label [wizLabel]="'$.wf.targets.$'"></wiz-label>
        <wiz-ag-grid #usersGrid
            width="100%"
            height="100%"
            class="ag-theme-alpine"
            [wizDatasource]="usersDS"
            [columnDefs]="usersColumns"
            [suppressRowClickSelection]="false"
            [wizRowSelection]="'multiple'"
        ></wiz-ag-grid>
        <filter-component #usersFilter width="100%" style="padding-top: 10px;"></filter-component>
       
      </viz-vgroup>




    </wiz-hgroup>
  </wiz-vgroup>
</wiz-h-divider>